export const presentationsData = {
  barletta: {
    title: 'Sala Rossa Castello Svevo Barletta',
    date: '3.3.2026',
    location: 'Castello Svevo, Barletta',
    video: 'https://www.youtube.com/watch?v=WIjryfc6MMI&t=5267s',
    videoId: 'WIjryfc6MMI',
  },
  cutrofiano: {
    title: 'Mercato della Cultura Cutrofiano (LE)',
    date: '21.03.2026',
    location: 'Cutrofiano, Lecce',
    video: null,
    videoId: null,
  },
  andria: {
    title: 'Comitato Elettorale Giovanna Bruno Sindaco',
    date: '27.4.2026',
    location: 'Andria',
    video: null,
    videoId: null,
  },
  lucera: {
    title: 'Circolo Unione Lucera',
    date: '20.5.2026',
    location: 'Lucera (FG)',
    video: null,
    videoId: null,
  },
  trani: {
    title: 'Versante Est',
    date: '30.8.2026',
    location: 'Trani',
    video: null,
    videoId: null,
  },
};

export const barlettaPhotos = [
  '/barletta1.jpg', '/barletta2.jpg', '/barletta3.jpg', '/barletta4.jpg', '/barletta5.jpg',
  '/barletta6.jpg', '/barletta7.jpg', '/barletta8.jpg', '/barletta9.jpg', '/barletta10.jpg',
];

export const cutrofianoPhotos = [
  '/cutrofiano1.jpg', '/cutrofiano2.jpg', '/cutrofiano3.jpg', '/cutrofiano4.jpg', '/cutrofiano5.jpg',
  '/cutrofiano6.jpg', '/cutrofiano7.jpg', '/cutrofiano8.jpg', '/cutrofiano9.jpg', '/cutrofiano10.jpg',
  '/cutrofiano11.jpg', '/cutrofiano12.jpg', '/cutrofiano13.jpg',
];

export const andriaPhotos = [
  '/comitato_andria1.jpg', '/comitato_andria2.jpg', '/comitato_andria3.jpg',
  '/comitato_andria4.jpg', '/comitato_andria5.jpg',
];

export const luceraPhotos = [
  '/lucera1.jpg', '/lucera2.jpg', '/lucera3.jpg', '/lucera4.jpg', '/lucera5.jpg', '/lucera6.jpg',
];

export const traniPhotos = [
  '/trani1.jpg', '/trani2.jpg', '/trani3.jpg', '/trani4.jpg',
  '/trani5.jpg', '/trani6.jpg', '/trani7.jpg', '/trani8.jpg',
];
